export interface GoogleIdConfiguration {
  client_id: string;
  callback: (response: { credential: string }) => void;
  auto_select?: boolean;
}

export interface GoogleButtonOptions {
  type?: 'standard' | 'icon';
  theme?: 'outline' | 'filled_blue' | 'filled_black';
  size?: 'small' | 'medium' | 'large';
  text?: 'signin_with' | 'signup_with' | 'continue_with' | 'signin';
  shape?: 'rectangular' | 'pill';
  width?: number | string;
}

interface GoogleAccountsId {
  initialize: (config: GoogleIdConfiguration) => void;
  renderButton: (parent: HTMLElement, options: GoogleButtonOptions) => void;
  prompt: () => void;
}

interface GoogleAccountsRoot {
  accounts: { id: GoogleAccountsId };
}

declare global {
  interface Window {
    google?: GoogleAccountsRoot;
  }
}

export const GOOGLE_CLIENT_ID =
  (import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined) ?? '';

export function waitForGoogleSdk(timeoutMs = 5000): Promise<GoogleAccountsId> {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    const tick = (): void => {
      if (window.google?.accounts?.id) {
        resolve(window.google.accounts.id);
        return;
      }
      if (Date.now() - start > timeoutMs) {
        reject(new Error('google_sdk_timeout'));
        return;
      }
      setTimeout(tick, 100);
    };
    tick();
  });
}
